import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import ReactPixel from "react-facebook-pixel";

import LogoWithLanguage from "../../../components/logo-with-language/LogoWithLanguage";
import LoginHero from "../../../assets/heroes/waiting-bg.png";

function BookingSuccessfullyPage() {
  const LocalBasePath = "page.signUpSuccessfully";
  const { t } = useTranslation("", {
    keyPrefix: LocalBasePath,
  });

  const navigate = useNavigate();
  const location = useLocation();

  const redirectTo = (location.state as { redirectTo?: string } | null)
    ?.redirectTo;

  useEffect(() => {
    ReactPixel.pageView();

    const gtag = (window as any).gtag;

    if (gtag) {
      gtag("config", "AW-18202443473", {
        page_path: window.location.pathname,
        page_location: window.location.href,
      });
    }

    if (!redirectTo) return;

    const timer = window.setTimeout(() => {
      navigate(redirectTo, { replace: true });
    }, 1500);

    return () => window.clearTimeout(timer);
  }, [navigate, redirectTo]);

  return (
    <div className="flex min-h-screen">
      <div className="flex flex-col justify-between flex-1 px-4 py-12 sm:px-6 lg:flex-none lg:px-24">
        <div className="flex flex-col items-center justify-center gap-4 sm:gap-0 sm:justify-between sm:flex-row">
          <LogoWithLanguage />
        </div>
        <div className="flex flex-col justify-center flex-1 w-full max-w-md">
          <div>
            <h2 className="mt-6 text-3xl font-bold text-gray-700">
              {t("sendInfoDone")}
            </h2>
            <p className="text-gray-500 text-lg mt-4">
              {t("bookingMessage")}
            </p>
          </div>
        </div>
      </div>
      <div className="relative flex-1 hidden w-0 lg:block">
        <img
          className="absolute inset-0 object-cover w-full h-full"
          src={LoginHero}
          alt=""
        />
      </div>
    </div>
  );
}

export default BookingSuccessfullyPage;
